import request from '@/utils/request'
import URL from '@/api/urlTranslator'

export function getChargeUnitList(params) {
  return request({
    url: URL.mdm.basicData.chargeUnitList,
    method: 'get',
    params
  })
}

export function saveChargeUnit(data) {
  return request({
    url: URL.mdm.basicData.chargeUnit,
    method: data.uuid ? 'put' : 'post',
    data
  })
}

export function delChargeUnit(uuid) {
  return request({
    url: URL.mdm.basicData.chargeUnit + '?uuid=' + encodeURIComponent(uuid),
    method: 'delete'
  })
}

export async function checkChargeUnits(data) {
  return request({
    url: URL.mdm.basicData.checkChargeUnit,
    method: 'post',
    data
  })
}
